var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h3',[_vm._v("About Page")]),_c('p',[_vm._v(_vm._s(_vm.their_name)+" Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ali...")])])}
var staticRenderFns = []

export { render, staticRenderFns }